import React from 'react';
import {
  ButtonToolbar,
  ButtonGroup,
  Button,
  Badge,
  Panel,
} from 'react-bootstrap';
import GroupDetailModal from './GroupDetailModal';

function findById(value) {
  console.log('findById ', value.id, this);
  return value.id === Number(this);
}

const renderToolbar = (value, name, edit, remove, members, readOnly) => {
  if (readOnly) {
    return (<div>{name} ({members} members)</div>);
  }
  return (
    <ButtonGroup>
      <Button name="Edit" bsSize="small" bsStyle="success" data-item={value} onClick={edit}>
        <i className="fa fa-pencil" />
      </Button>
      <Button name="Remove" bsSize="small" bsStyle="success" data-item={value} onClick={remove}>
        <i className="fa fa-trash-o" />
      </Button>
      &nbsp;{name} ({members} members)
    </ButtonGroup>);
};
// <Badge>{members}</Badge>
class TourRosterGroups extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      opened: true,
    };
    this.toggleBox = this.toggleBox.bind(this);
    this.remove = this.remove.bind(this);
    this.showGroup = this.showGroup.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  toggleBox() {
    const { opened } = this.state;
    this.setState({
      // toggle value of `opened`
      opened: !opened,
    });
  }
  closeModal() {
    this.setState({
      show: false,
      group: null,
    });
  }
  remove(e) {
    const id = e.currentTarget.getAttribute('data-item');
    e.preventDefault();
    if (id) {
      this.findGroup(this.state.group);
      this.props.removeGroup(this.findGroup(id));
    }
  }
  showGroup(e) {
    e.preventDefault();
    const id = e.currentTarget.getAttribute('data-item');
    if (id) {
      this.setState({
        group: id,
        show: true,
      });
    }
  }
  findGroup(id) {
    const idx = this.props.groups.findIndex(findById, id);
    if (idx === -1) {
      console.log('findGroup that should not happen...', id);
      return {};
    }
    return this.props.groups[idx];
  }

  render() {
    const groups = this.props.groups.map(group =>
      <li key={group.id} >
        { renderToolbar(
            group.id,
            group.name,
            this.showGroup,
            this.remove,
            group.members_count,
            this.props.readOnly,
          ) }
      </li>,
    );
    const { opened } = this.state;
    return (
      <div>
        <h3>Groups <span className="badge">{groups.length}</span>
          <i
            className={opened ? 'fa fa-angle-up' : 'fa fa-angle-down'}
            aria-hidden="true"
            onClick={this.toggleBox}
          />
        </h3>
        { opened && (
          <ul className="groups">
            {groups}
          </ul>
        )}
        { this.state.show && (
        <GroupDetailModal
          group={this.findGroup(this.state.group)}
          show={this.state.show}
          onClose={this.closeModal}
          editGroup={this.props.editGroup}
          editing={!this.props.readOnly}
        />
        )}
      </div>
    );
  }
}
export default TourRosterGroups;



// WEBPACK FOOTER //
// src/routes/tours/components/TourRosterGroups.js